import { Component, DestroyRef, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FloatingComponentService } from '../../core/services/floating-component.service';

@Component({
  selector: 'ai-floating-panel',
  imports: [MatIconModule, MatButtonModule, MatCardModule],
  templateUrl: './floating-panel.component.html',
  styleUrls: ['./floating-panel.component.scss'],
})
export class FloatingPanelComponent {
  readonly autoClosing = signal(false);

  private readonly floatingService = inject(FloatingComponentService);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly isClosing = signal(false);
  private closeTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    this.destroyRef.onDestroy(() => {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
    });
  }

  close(): void {
    if (this.isClosing()) return;

    this.isClosing.set(true);

    this.closeTimeout = setTimeout(() => {
      this.floatingService.close();
    }, 300);
  }
}
